import { render, staticRenderFns } from "./customSelect.vue?vue&type=template&id=b760b0b4&"
import script from "./customSelect.vue?vue&type=script&lang=js&"
export * from "./customSelect.vue?vue&type=script&lang=js&"
import style0 from "./customSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports